const { debounce } = require('./util/debounce');

export default () => jQuery(($) => {
    var bannerMini = $('.home-page-banner-mini');
    /* var backgrounder = $('<div class="home-page-banner-mini__backgrounder" />');
    var setBackgrounderHeight = debounce(function(){
        backgrounder.css("height", bannerMini.outerHeight() + 'px');
    }, 100);
    bannerMini.addClass("home-page-banner-mini--with-backgrounder").after(backgrounder);
    $(window).resize(function(){setBackgrounderHeight()});
    $(document).load(function(){
        setBackgrounderHeight();
    });
    setBackgrounderHeight(); */
    bannerMini.find('.search-form__discloser').click(function(){
        bannerMini.addClass('home-page-banner-mini--search-expanded');
    });

    if(bannerMini.attr('data-exclude-visibility').length) {
        if(!!window.IntersectionObserver) {
            const exclusionElements = $(bannerMini.attr('data-exclude-visibility'));
            let observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.intersectionRatio > 0) {
                            if(!bannerMini.hasClass("home-page-banner-mini--hidden")) {
                                bannerMini.addClass("home-page-banner-mini--hidden");
                            }
                        } else {
                            if(bannerMini.hasClass("home-page-banner-mini--hidden")) {
                                bannerMini.removeClass("home-page-banner-mini--hidden");
                                // setBackgrounderHeight();
                            }
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0
                }
            );
            exclusionElements.each(function(){
                observer.observe($(this)[0]);
            });
        } else {
            // hide entirely if browser doesn't have intersectionObserver
            bannerMini.addClass("home-page-banner-mini--hidden");
        }
    }
});
